import { atom } from "jotai";
import { Recording } from "@quantizr-engineering/common/types/recording";
import { Release } from "../pages/Analytics/Recorded";

export interface RecordedState {
  loading: boolean;
  data: Release[] | null;
  lastFetched: number | null;
}

export const recordedAtom = atom<RecordedState>({
  loading: false,
  data: [],
  lastFetched: null,
});

export const recordedLoadingAtom = atom<boolean>(false);

export const recordedErrorAtom = atom<string | null>(null);

export const selectedRecordedAtom = atom(null, (get, _set, id: number) => {
  const recordings = get(recordedAtom);
  return recordings.data?.find((s) => s.id === id);
});
